module.exports = __webpack_public_path__ + "img/bar-lubitsch-10.19.24.96b416cb.png";